import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import NotificationClose from './NotificationClose';
import { calculateRem } from '@uie/javascript-style-helpers';
import { breakpoints, verizonTheme as colors, calculateSpacing } from '@vds-core/theme';
import { Body, BodyConfig, TitleConfig, TypographyConfig } from '@vds-core/typography';
import Icon, { IconData } from '@vds-core/icons';
import { withVDSManager } from '@vds-core/utilities';
import cuid from 'cuid';

function _calculateContentColor(alertType, type, colorConfig) {
  if (alertType === 'warning' || type === 'warning') {
    return colorConfig.textColorWarning;
  } else {
    return colorConfig.white;
  }
}

var _animateIn = function _animateIn(containerHeight) {
  return keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    0% {\n      opacity: 0;\n      height: 0;\n      padding-top: 0;\n      padding-bottom: 0;\n    }\n    100% {\n      opacity: 1;\n      padding-top: ", ";\n      padding-bottom: ", ";\n    }"])), calculateSpacing('5X'), calculateSpacing('5X'));
};

var _animateOut = function _animateOut(containerHeight) {
  return keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    0% {\n      opacity: 1;\n      padding-top: ", ";\n      padding-bottom: ", ";\n    }\n    100% {\n      opacity: 0;\n      height: 0;\n      padding-top: 0;\n      padding-bottom: 0;\n    }"])), calculateSpacing('5X'), calculateSpacing('5X'));
};

var propTypes = {
  /**
   * @deprecated type
   */
  alertType: PropTypes.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * This will render the contents of the Notification.  Not compatible with Title/Subtitle props.
   * @note If you want to leverage out of the box accessibility, be sure to use the provided title/subtitle/buttonData props. Otherwise, you are responsible for making sure the component is fully accessible.
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @deprecated hideCloseButton
   */
  showCloseIcon: PropTypes.bool,

  /**
   * Add prop to disable all animations.
   */
  disableAnimation: PropTypes.bool,

  /**
   * @deprecated opened
   */
  showAlert: PropTypes.bool,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object,

  /**
   * Callback for when the close button is clicked.
   */
  onCloseButtonClick: PropTypes.func,

  /**
   * Add this attribute determine your type of Notification.
   */
  type: PropTypes.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * Add prop to toggle Notification can only be used when hideCloseButton is set to true.
   */
  opened: PropTypes.bool,

  /**
   * Prop that displays the icon that allows for dismissing of Notification
   */
  hideCloseButton: PropTypes.bool,

  /**
   * @ignore
   * renders the icon on the left of the notification bar
   */
  showNotificationIcon: PropTypes.bool,

  /**
   * @ignore
   * passes icon data through
   */
  iconConfig: PropTypes.object,

  /**
   * @ignore
   * adds a focus state around the close icon, removes default browser outline from the container
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   * adds a active state around the close icon
   */
  activeState: PropTypes.bool,

  /**
   * @ignore
   * adds max-width to notification container
   */
  maxWidth: PropTypes.string,

  /**
   * @ignore
   * adds min-height to notification container
   */
  minHeight: PropTypes.string,

  /**
   * @ignore
   * if true, turns off maxWidth so that the container goes full width on viewport
   */
  fullBleed: PropTypes.bool,

  /**
   * @ignore
   * passes through config file for Body component
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   * changes color of the content inside of the notification wrapper
   */
  contentColor: PropTypes.func,

  /**
   * @ignore
   * creates animation in
   */
  animateIn: PropTypes.func,

  /**
   * @ignore
   * creates animation out
   */
  animateOut: PropTypes.func,

  /**
   * @ignore
   * defines properties of the animations on animateIn and animateOut
   */
  animationProperties: PropTypes.string,

  /**
   * @ignore
   * used for title typogrpahy
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * @ignore
   * used for subtitle typography
   */
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * @ignore
   * If provided, Button components will be rendered based on this data
   */
  buttonData: PropTypes.arrayOf(PropTypes.shape({
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    onClick: PropTypes.func
  })),

  /**
   * @ignore
   */
  unMountTime: PropTypes.number,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-track': PropTypes.string,

  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-level': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-position': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-datatrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-cta': PropTypes.string,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * @ignore If passed, the Body component from VDS will render
   */
  Body: PropTypes.func,

  /**
   * @ignore If passed, the ButtonGroup component from VDS will render
   */
  ButtonGroup: PropTypes.func,

  /**
   * @ignore
   */
  titleConfig: PropTypes.object,

  /**
   * Viewport to configure how the modal will be rendered.
   */
  viewport: PropTypes.oneOf(['mobile', 'desktop', 'tablet'])
};
var defaultProps = {
  children: null,
  className: null,
  showCloseIcon: false,
  disableAnimation: false,
  showAlert: false,
  colorConfig: colors,
  onCloseButtonClick: function onCloseButtonClick() {},
  //added after renaming
  type: 'success',
  opened: false,
  hideCloseButton: false,
  showNotificationIcon: false,
  iconConfig: IconData,
  focusState: false,
  activeState: false,
  bodyConfig: BodyConfig,
  contentColor: _calculateContentColor,
  fullBleed: false,
  maxWidth: undefined,
  minHeight: undefined,
  animateIn: _animateIn,
  animateOut: _animateOut,
  animationProperties: '0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both',
  unMountTime: 400,
  Body: Body,
  viewport: 'desktop'
};
var fadeInMobile = /*#__PURE__*/keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n    height: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  100% {\n    opacity: 1;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    }\n"])), calculateSpacing('4X'), calculateSpacing('4X'));
var fadeOutMobile = /*#__PURE__*/keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n    padding-top: ", ";\n    padding-bottom: ", ";\n  }\n  100% {\n    opacity: 0;\n    height: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n"])), calculateSpacing('4X'), calculateSpacing('4X'));

var determineType = function determineType(_ref) {
  var colorConfig = _ref.colorConfig,
      alertType = _ref.alertType,
      type = _ref.type;

  if (alertType) {
    switch (alertType) {
      case 'error':
        return "\n          background-color: ".concat(colorConfig.orange, ";\n        ");

      case 'info':
        return "\n          background-color: ".concat(colorConfig.blue, ";\n          ");

      case 'warning':
        return "\n          background-color: ".concat(colorConfig.yellow, ";\n          ");

      default:
        return "\n          background-color: ".concat(colorConfig.green, ";\n          ");
    }
  }
  /* istanbul ignore else  */


  if (type) {
    switch (type) {
      case 'error':
        return "\n        background-color: ".concat(colorConfig.orange, ";\n      ");

      case 'info':
        return "\n        background-color: ".concat(colorConfig.blue, ";\n        ");

      case 'warning':
        return "\n        background-color: ".concat(colorConfig.yellow, ";\n        ");

      default:
        return "\n        background-color: ".concat(colorConfig.green, ";\n        ");
    }
  }
};

var StyledDiv = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledDiv",
  componentId: "sc-1383qpl-0"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  max-width: ", ";\n  width: 100%;\n  outline: none;\n\n  ", ";\n"])), function (_ref2) {
  var maxWidth = _ref2.maxWidth,
      fullBleed = _ref2.fullBleed;
  return fullBleed ? null : maxWidth;
}, function (_ref3) {
  var focusState = _ref3.focusState;
  return focusState && "\n    &:focus {\n      outline: none;\n    }\n    ";
});
var AlertWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "AlertWrapper",
  componentId: "sc-1383qpl-1"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  opacity: 0;\n  overflow: hidden;\n  box-sizing: border-box;\n  padding: ", ";\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: ", ";\n  opacity: 0;\n  margin: 0\n    ", ";\n  min-height: ", ";\n\n  transition: ", ";\n\n  ", ";\n  ", ";\n\n  outline: none;\n  @media screen and (max-width: ", ") {\n    box-sizing: border-box;\n\n    padding: ", ";\n    transition: ", ";\n    ", ";\n    ", ";\n  }\n\n  &:active,\n  &:visited,\n  &:hover {\n    outline: none;\n  }\n  * {\n    &:active,\n    &:visited,\n    &:hover {\n      outline: none;\n    }\n  }\n"])), function (_ref4) {
  var colorConfig = _ref4.colorConfig,
      alertType = _ref4.alertType,
      type = _ref4.type;
  return (alertType || type) && determineType({
    colorConfig: colorConfig,
    alertType: alertType,
    type: type
  });
}, calculateRem(20), function (_ref5) {
  var fullBleed = _ref5.fullBleed;
  return fullBleed ? 'center' : 'space-between';
}, function (_ref6) {
  var inlineTreatment = _ref6.inlineTreatment,
      fullBleed = _ref6.fullBleed;
  return inlineTreatment && !fullBleed ? calculateSpacing('5X') : 0;
}, function (_ref7) {
  var minHeight = _ref7.minHeight;
  return minHeight;
}, function (_ref8) {
  var disableAnimation = _ref8.disableAnimation;
  return disableAnimation ? 0 : 'all ease 0.2s';
}, function (_ref9) {
  var disableAnimation = _ref9.disableAnimation,
      animateIn = _ref9.animateIn,
      containerHeight = _ref9.containerHeight,
      animationProperties = _ref9.animationProperties;
  return !disableAnimation && containerHeight && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      animation: ", " ", ";\n    "])), animateIn(containerHeight), animationProperties);
}, function (_ref10) {
  var unmounted = _ref10.unmounted,
      animateOut = _ref10.animateOut,
      containerHeight = _ref10.containerHeight,
      animationProperties = _ref10.animationProperties;
  return unmounted && containerHeight && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      animation: ", " ", ";\n    "])), animateOut(containerHeight), animationProperties);
}, breakpoints.md, calculateRem(16), function (_ref11) {
  var disableAnimation = _ref11.disableAnimation;
  return disableAnimation ? 0 : 'all ease 0.2s';
}, function (_ref12) {
  var disableAnimation = _ref12.disableAnimation,
      hasViewport = _ref12.hasViewport,
      animateIn = _ref12.animateIn,
      containerHeight = _ref12.containerHeight,
      animationProperties = _ref12.animationProperties;
  return !disableAnimation && containerHeight && css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        animation: ", "\n          ", ";\n      "])), hasViewport ? animateIn(containerHeight) : fadeInMobile, animationProperties);
}, function (_ref13) {
  var unmounted = _ref13.unmounted,
      hasViewport = _ref13.hasViewport,
      animateOut = _ref13.animateOut,
      containerHeight = _ref13.containerHeight,
      animationProperties = _ref13.animationProperties;
  return unmounted && containerHeight && css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        animation: ", "\n          ", ";\n      "])), hasViewport ? animateOut(containerHeight) : fadeOutMobile, animationProperties);
});
var TextAreaWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TextAreaWrapper",
  componentId: "sc-1383qpl-2"
})(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: ", ";\n  justify-content: space-between;\n  width: 100%;\n  box-sizing: border-box;\n\n  @media screen and (min-width: ", ") {\n    ", ";\n  }\n  @media screen and (max-width: ", ") {\n    ", ";\n  }\n\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n"])), function (_ref14) {
  var isIe = _ref14.isIe;
  return isIe ? "1 1 0" : "1 1 0%";
}, breakpoints.lg, function (_ref15) {
  var layout = _ref15.layout,
      halfWidth = _ref15.halfWidth;
  return layout !== 'horizontal' && layout !== 'vertical' && "\n        max-width: ".concat(halfWidth ? '50%' : '100%', ";\n        padding-right: ").concat(halfWidth ? calculateSpacing('5X') : '28px', ";\n    ");
}, breakpoints.lg, function (_ref16) {
  var layout = _ref16.layout,
      halfWidth = _ref16.halfWidth;
  return layout !== 'horizontal' && "\n      padding-right: 28px;\n      max-width: 100%;\n    ";
}, function (_ref17) {
  var viewport = _ref17.viewport,
      layout = _ref17.layout,
      halfWidth = _ref17.halfWidth;
  return layout !== 'horizontal' && layout !== 'vertical' && viewport === 'desktop' && "\n      max-width: ".concat(halfWidth ? '50%' : '100%', ";\n      padding-right: ").concat(halfWidth ? calculateSpacing('5X') : '28px', ";\n  ");
}, function (_ref18) {
  var viewport = _ref18.viewport,
      layout = _ref18.layout;
  return layout !== 'horizontal' && viewport !== 'desktop' && "\n      max-width: 100%;\n      padding-right: 28px;\n  ";
}, function (_ref19) {
  var layout = _ref19.layout;
  return layout === 'vertical' && "\n      max-width: 100%;\n  ";
}, function (_ref20) {
  var layout = _ref20.layout,
      halfWidth = _ref20.halfWidth;
  return layout === 'horizontal' && "\n      max-width: ".concat(halfWidth ? '50%' : '100%', ";\n      padding-right: ").concat(halfWidth ? calculateSpacing('5X') : '28px', ";\n  ");
});
var ButtonAreaWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "ButtonAreaWrapper",
  componentId: "sc-1383qpl-3"
})(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: ", ";\n  justify-content: space-between;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  padding-right: 28px;\n  @media screen and (min-width: ", ") {\n    ", ";\n  }\n  @media screen and (max-width: ", ") {\n    ", ";\n  }\n\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n"])), function (_ref21) {
  var isIe = _ref21.isIe;
  return isIe ? "1 1 0" : "1 1 0%";
}, breakpoints.lg, function (_ref22) {
  var layout = _ref22.layout;
  return layout !== 'horizontal' && layout !== 'vertical' && "\n        max-width: 50%;\n        padding-left: ".concat(calculateSpacing('5X'), ";\n    ");
}, breakpoints.lg, function (_ref23) {
  var layout = _ref23.layout;
  return layout !== 'horizontal' && "\n      max-width: 100%;\n      padding-left: ".concat(calculateSpacing('8X'), ";\n    ");
}, function (_ref24) {
  var viewport = _ref24.viewport,
      layout = _ref24.layout;
  return layout !== 'horizontal' && layout !== 'vertical' && viewport === 'desktop' && "\n      max-width: 50%;\n      padding-left: ".concat(calculateSpacing('5X'), ";\n\n  ");
}, function (_ref25) {
  var viewport = _ref25.viewport,
      layout = _ref25.layout;
  return layout !== 'horizontal' && viewport !== 'desktop' && "\n      max-width: 100%;\n      padding-left: ".concat(calculateSpacing('8X'), ";\n  ");
}, function (_ref26) {
  var layout = _ref26.layout;
  return layout === 'vertical' && "\n      max-width: 100%;\n      padding-left: ".concat(calculateSpacing('8X'), ";\n  ");
}, function (_ref27) {
  var layout = _ref27.layout;
  return layout === 'horizontal' && "\n      max-width: 50%;\n      padding-left: ".concat(calculateSpacing('5X'), ";\n  ");
});
var TextWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "TextWrapper",
  componentId: "sc-1383qpl-4"
})(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  flex-direction: column;\n  flex: 1;\n  display: flex;\n"])));
var Title = /*#__PURE__*/styled.div.withConfig({
  displayName: "Title",
  componentId: "sc-1383qpl-5"
})(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  color: ", ";\n  max-width: 80%;\n  outline: none;\n  ", ";\n  ", ";\n"])), function (props) {
  return props.color;
}, function (_ref28) {
  var desktopConfig = _ref28.desktopConfig,
      mobileConfig = _ref28.mobileConfig,
      color = _ref28.color;
  return "\n    font-size: ".concat(calculateRem(desktopConfig.fontSize), ";\n    line-height: ").concat(calculateRem(desktopConfig.lineHeight), ";\n    font-family: ").concat(desktopConfig.fontFamily, ";\n    letter-spacing: ").concat(calculateRem(desktopConfig.letterSpacing), ";\n    font-weight: bold;\n    color: ").concat(color, ";\n    @media screen and (max-width: ").concat(breakpoints.md, ") {\n      max-width: 80%;\n      padding-bottom: 0;\n      outline: none;\n      font-size: ").concat(calculateRem(mobileConfig.fontSize), ";\n      line-height: ").concat(calculateRem(mobileConfig.lineHeight), ";\n      font-family: ").concat(mobileConfig.fontFamily, ";\n      letter-spacing: ").concat(calculateRem(mobileConfig.letterSpacing), ";\n      font-weight: bold;\n    }\n  ");
}, function (_ref29) {
  var viewport = _ref29.viewport,
      mobileConfig = _ref29.mobileConfig;
  return viewport === 'mobile' && "\n    max-width: 80%;\n    padding-bottom: 0;\n    outline: none;\n    font-size: ".concat(calculateRem(mobileConfig.fontSize), ";\n    line-height: ").concat(calculateRem(mobileConfig.lineHeight), ";\n    font-family: ").concat(mobileConfig.fontFamily, ";\n    letter-spacing: ").concat(calculateRem(mobileConfig.letterSpacing), ";\n    font-weight: bold;\n  ");
});
var ContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ContentWrapper",
  componentId: "sc-1383qpl-6"
})(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  position: relative;\n  max-width: 1272px;\n  justify-content: ", ";\n\n  @media screen and (max-width: ", ") {\n    overflow: visible;\n  }\n  ", ";\n  ", ";\n  ", ";\n"])), function (_ref30) {
  var contentTitle = _ref30.contentTitle,
      subtitle = _ref30.subtitle;
  return !contentTitle && !subtitle && 'space-between';
}, breakpoints.sm, function (_ref31) {
  var viewport = _ref31.viewport;
  return (viewport === 'tablet' || viewport === 'mobile') && "\n    flex-direction: column;\n  ";
}, function (_ref32) {
  var layout = _ref32.layout;
  return layout === 'vertical' && "\n    flex-direction: column;\n  ";
}, function (_ref33) {
  var layout = _ref33.layout;
  return layout === 'horizontal' && "\n    flex-direction: row;\n  ";
});
var NotificationIconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "NotificationIconWrapper",
  componentId: "sc-1383qpl-7"
})(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  margin-right: ", ";\n"])), calculateSpacing('3X')); //margin-bottom is applied to cancel out the padding-bottom applied to ButtonGroup component

var ButtonWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ButtonWrapper",
  componentId: "sc-1383qpl-8"
})(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  max-width: 100%;\n  margin-bottom: ", ";\n  flex: 1;\n  display: flex;\n  align-items: center;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  @media screen and (max-width: ", ") {\n    width: inherit;\n  }\n  button {\n    margin: 0;\n  }\n"])), function (_ref34) {
  var buttonData = _ref34.buttonData;
  return buttonData && buttonData.length === 1 ? 0 : "-".concat(calculateSpacing('4X'));
}, function (_ref35) {
  var layout = _ref35.layout;
  return layout !== 'vertical' && layout !== 'horizontal' && "\n    @media screen and (min-width: ".concat(breakpoints.lg, ") {\n      margin-top: 0;\n      margin-left: 0;\n    }\n  ");
}, function (_ref36) {
  var viewport = _ref36.viewport,
      layout = _ref36.layout;
  return viewport === 'desktop' && layout !== 'vertical' && layout !== 'horizontal' && "\n    margin-top: 0;\n    margin-left: 0;\n  ";
}, function (_ref37) {
  var layout = _ref37.layout;
  return layout !== 'vertical' && layout !== 'horizontal' && "\n    @media screen and (max-width: ".concat(breakpoints.lg, ") {\n      margin-top: ").concat(calculateRem(12), ";\n      margin-left: 0;\n    }\n  ");
}, function (_ref38) {
  var viewport = _ref38.viewport,
      layout = _ref38.layout;
  return viewport !== 'desktop' && layout !== 'vertical' && layout !== 'horizontal' && "\n    margin-top: ".concat(calculateRem(12), ";\n    margin-left: 0;\n  ");
}, function (_ref39) {
  var layout = _ref39.layout;
  return layout === 'horizontal' && "\n      margin-top: 0;\n      margin-left: 0;\n  ";
}, function (_ref40) {
  var layout = _ref40.layout;
  return layout === 'vertical' && "\n      margin-top: ".concat(calculateRem(12), ";\n      margin-left: 0;\n  ");
}, breakpoints.sm);
var TextIconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TextIconWrapper",
  componentId: "sc-1383qpl-9"
})(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  display: flex;\n  flex: 1;\n"]))); // Necessary to concatenate type notification with title for screen readers

var AccessibilityLabel = /*#__PURE__*/styled.span.attrs(function () {
  return {
    ariaHidden: true
  };
}).withConfig({
  displayName: "AccessibilityLabel",
  componentId: "sc-1383qpl-10"
})(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  whitespace: nowrap;\n  border: 0;\n"])));

var Notification = /*#__PURE__*/function (_Component) {
  _inherits(Notification, _Component);

  var _super = _createSuper(Notification);

  function Notification(props) {
    var _this;

    _classCallCheck(this, Notification);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "isAppleDevice", function () {
      return /iPhone|iPad/i.test(navigator.userAgent);
    }());

    _defineProperty(_assertThisInitialized(_this), "_checkIfIe", function () {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf('MSIE ');
      var trident = ua.indexOf('Trident/');
      return trident > 0 || msie > 0;
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      var _this$props = _this.props,
          showAlert = _this$props.showAlert,
          opened = _this$props.opened,
          disableAnimation = _this$props.disableAnimation;

      if (showAlert || opened) {
        console.warn('When using the showAlert/opened Prop you must set the hideCloseButton to true');
        return;
      }

      if (!disableAnimation) {
        _this.setState(function () {
          return {
            unmounted: true
          };
        });

        _this.props.onCloseButtonClick();

        _this.unMountTimer = setTimeout(function () {
          _this.setState({
            visible: false
          });
        }, _this.props.unMountTime);
      } else {
        _this.setState(function () {
          return {
            visible: false
          };
        });

        _this.props.onCloseButtonClick();
      }

      _this.wrapper && _this.wrapper.blur();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var buttonData = _this.props.buttonData;

      _this.setState({
        containerHeight: _this.wrapper ? _this.wrapper.clientHeight : _this.props.minHeight || '100%'
      });
      /*Role is alert initially so the notification is announced on mount, but then switches to role text so that when arrow keyed to, it also reads alert. (See AccessibilityLabel)*/


      _this.roleTimer = setTimeout(function () {
        _this.setState({
          role: 'text'
        });
      }, _this.props.unMountTime);
      buttonData && document.getElementById('notificationCloseButton').focus();
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearTimeout(_this.unMountTimer);
      clearTimeout(_this.roleTimer);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props2 = _this.props,
          showCloseIcon = _this$props2.showCloseIcon,
          hideCloseButton = _this$props2.hideCloseButton,
          showAlert = _this$props2.showAlert,
          opened = _this$props2.opened;

      if ((!showCloseIcon || hideCloseButton) && prevProps.showAlert !== showAlert) {
        _this.setState(function () {
          return {
            visible: !prevProps.showAlert
          };
        });
      }

      if ((!showCloseIcon || hideCloseButton) && prevProps.opened !== opened) {
        _this.setState(function () {
          return {
            visible: !prevProps.opened
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderIconElement", function () {
      var _this$props3 = _this.props,
          alertType = _this$props3.alertType,
          type = _this$props3.type,
          showCloseIcon = _this$props3.showCloseIcon,
          hideCloseButton = _this$props3.hideCloseButton,
          showNotificationIcon = _this$props3.showNotificationIcon,
          iconConfig = _this$props3.iconConfig,
          focusState = _this$props3.focusState,
          activeState = _this$props3.activeState,
          colorConfig = _this$props3.colorConfig,
          hitArea = _this$props3.hitArea,
          contentColor = _this$props3.contentColor,
          closeButtonHeight = _this$props3.closeButtonHeight,
          buttonData = _this$props3.buttonData,
          cta = _this$props3['data-sitecat-cta'],
          dataTrack = _this$props3['data-sitecat-datatrack'],
          position = _this$props3['data-sitecat-position'],
          level = _this$props3['data-sitecat-level'];
      var visible = _this.state.visible;

      if (!hideCloseButton || showCloseIcon) {
        return /*#__PURE__*/React.createElement(NotificationClose, {
          id: "notificationCloseButton",
          closeButtonHeight: closeButtonHeight,
          hitArea: hitArea,
          contentColor: contentColor(alertType, type, colorConfig),
          colorConfig: colorConfig,
          focusState: focusState,
          activeState: activeState,
          iconConfig: iconConfig,
          size: showNotificationIcon ? 'small' : 'medium',
          alertType: alertType,
          type: type,
          controlFunc: _this.close,
          visible: visible,
          buttonData: buttonData,
          cta: cta,
          dataTrack: dataTrack,
          position: position,
          level: level
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderNotificationIcon", function () {
      var _this$props4 = _this.props,
          showNotificationIcon = _this$props4.showNotificationIcon,
          colorConfig = _this$props4.colorConfig,
          alertType = _this$props4.alertType,
          iconConfig = _this$props4.iconConfig,
          type = _this$props4.type,
          contentColor = _this$props4.contentColor;
      if (!showNotificationIcon) return;
      return /*#__PURE__*/React.createElement(NotificationIconWrapper, {
        tabIndex: -1,
        "aria-hidden": true
      }, /*#__PURE__*/React.createElement(Icon, {
        tabIndex: -1,
        ariaHidden: true,
        data: iconConfig,
        medium: true,
        hasStroke: true,
        alertType: alertType,
        type: type,
        name: alertType || type,
        color: contentColor(alertType, type, colorConfig),
        size: "medium"
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "_determineTitleConfig", function () {
      var titleConfig = _this.props.titleConfig;
      var config = titleConfig ? titleConfig : TitleConfig,
          typescale = titleConfig ? 'VDS' : 'MVP',
          size = titleConfig ? 'large' : 'extraSmall',
          titleExtraSmallDesktop = config.getStyles(typescale, 'desktop', size),
          titleExtraSmallMobile = config.getStyles(typescale, 'mobile', size);
      return {
        mobile: titleExtraSmallMobile,
        desktop: titleExtraSmallDesktop
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderText", function () {
      var _this$props5 = _this.props,
          alertType = _this$props5.alertType,
          type = _this$props5.type,
          colorConfig = _this$props5.colorConfig,
          bodyConfig = _this$props5.bodyConfig,
          title = _this$props5.title,
          subtitle = _this$props5.subtitle,
          children = _this$props5.children,
          contentColor = _this$props5.contentColor,
          Body = _this$props5.Body,
          buttonData = _this$props5.buttonData,
          viewport = _this$props5.viewport,
          layout = _this$props5.layout;

      if (title && !subtitle) {
        return /*#__PURE__*/React.createElement(TextAreaWrapper, {
          halfWidth: buttonData !== undefined,
          viewport: viewport,
          layout: layout,
          isIe: _this._checkIfIe(),
          role: _this.isAppleDevice.toString() === 'true' ? 'alert' : undefined,
          "aria-live": _this.isAppleDevice.toString() === 'true' ? 'assertive' : undefined
        }, /*#__PURE__*/React.createElement(TextIconWrapper, null, _this.renderNotificationIcon(), /*#__PURE__*/React.createElement(TextWrapper, {
          viewport: viewport,
          layout: layout,
          "aria-labelledby": _this.typeID,
          role: _this.isAppleDevice.toString() === 'true' ? 'text' : _this.state.role // necessary for VoiceOver

        }, /*#__PURE__*/React.createElement(AccessibilityLabel, {
          id: _this.typeID
        }, _this.state.role === 'text' || _this.isAppleDevice.toString() === 'true' ? "Alert! ".concat(type, " notification ").concat(title) : "".concat(type, " notification")), /*#__PURE__*/React.createElement(Body, {
          id: _this.titleID,
          bold: true,
          size: "large",
          color: contentColor(alertType, type, colorConfig),
          config: bodyConfig,
          typescale: "VDS"
        }, title))), (layout === 'vertical' || buttonData === undefined) && _this.renderIconElement());
      } else if (title && subtitle) {
        return /*#__PURE__*/React.createElement(TextAreaWrapper, {
          halfWidth: buttonData !== undefined,
          viewport: viewport,
          layout: layout,
          isIe: _this._checkIfIe(),
          role: _this.isAppleDevice.toString() === 'true' ? 'alert' : undefined,
          "aria-live": _this.isAppleDevice.toString() === 'true' ? 'assertive' : undefined
        }, /*#__PURE__*/React.createElement(TextIconWrapper, null, _this.renderNotificationIcon(), /*#__PURE__*/React.createElement(TextWrapper, {
          viewport: viewport,
          layout: layout,
          "aria-labelledby": _this.typeID,
          "aria-describedby": _this.subtitleID,
          role: _this.isAppleDevice.toString() === 'true' ? 'text' : _this.state.role // necessary for VoiceOver

        }, /*#__PURE__*/React.createElement(AccessibilityLabel, {
          id: _this.typeID
        }, _this.state.role === 'text' || _this.isAppleDevice.toString() === 'true' ? "Alert! ".concat(type, " notification ").concat(title, " ").concat(subtitle) : "".concat(type, " notification")), /*#__PURE__*/React.createElement(Body, {
          id: _this.titleID,
          bold: true,
          size: "large",
          color: contentColor(alertType, type, colorConfig),
          config: bodyConfig,
          typescale: "VDS"
        }, title), /*#__PURE__*/React.createElement(Body, {
          id: _this.subtitleID,
          size: "large",
          color: contentColor(alertType, type, colorConfig),
          config: bodyConfig,
          typescale: "VDS"
        }, subtitle))), (layout === 'vertical' || buttonData === undefined) && _this.renderIconElement());
      } else {
        return /*#__PURE__*/React.createElement(TextAreaWrapper, {
          halfWidth: buttonData !== undefined,
          viewport: viewport,
          layout: layout,
          isIe: _this._checkIfIe(),
          role: _this.isAppleDevice.toString() === 'true' ? 'alert' : undefined,
          "aria-live": _this.isAppleDevice.toString() === 'true' ? 'assertive' : undefined
        }, _this.renderNotificationIcon(), /*#__PURE__*/React.createElement(TextWrapper, {
          "aria-labelledby": _this.state.role === 'text' ? "".concat(_this.typeID, " ").concat(_this.childrenId) : _this.typeID,
          role: _this.isAppleDevice.toString() === 'true' ? 'text' : _this.state.role // necessary for VoiceOver

        }, /*#__PURE__*/React.createElement(AccessibilityLabel, {
          id: _this.typeID
        }, _this.state.role === 'text' || _this.isAppleDevice.toString() === 'true' ? "Alert! ".concat(type, " notification") : "".concat(type, " notification")), /*#__PURE__*/React.createElement(Title, {
          color: contentColor(alertType, type, colorConfig),
          viewport: viewport,
          id: _this.childrenId,
          mobileConfig: _this._determineTitleConfig().mobile,
          desktopConfig: _this._determineTitleConfig().desktop
        }, children)), buttonData === undefined && _this.renderIconElement());
      }
    });

    _defineProperty(_assertThisInitialized(_this), "parseButtonData", function () {
      var _this$props6 = _this.props,
          type = _this$props6.type,
          alertType = _this$props6.alertType,
          buttonData = _this$props6.buttonData;
      var buttonDetail = [];
      var isInverted = type === 'info' || type === 'success' ||
      /* istanbul ignore next */
      alertType === 'info' ||
      /* istanbul ignore next */
      alertType === 'success';
      buttonData.length > 2 && buttonData.splice(2);
      buttonData.forEach(function (data, index) {
        buttonDetail.push(_objectSpread({}, data));
        /* istanbul ignore else  */

        if (index === 0 && !data.hasOwnProperty('type') || index === 1) {
          buttonDetail[index].type = 'secondary';
        }

        buttonDetail[index].size = 'small';
        buttonDetail[index].inverted = isInverted;
      });
      return buttonDetail;
    });

    _defineProperty(_assertThisInitialized(_this), "renderButtons", function () {
      var _this$props7 = _this.props,
          buttonData = _this$props7.buttonData,
          ButtonGroup = _this$props7.ButtonGroup,
          layout = _this$props7.layout,
          viewport = _this$props7.viewport;
      return /*#__PURE__*/React.createElement(Fragment, null, layout !== 'vertical' && buttonData && _this.renderIconElement(), /*#__PURE__*/React.createElement(ButtonAreaWrapper, {
        viewport: viewport,
        layout: layout,
        isIe: _this._checkIfIe()
      }, /*#__PURE__*/React.createElement(ButtonWrapper, {
        layout: layout,
        viewport: viewport,
        buttonData: buttonData
      }, buttonData && /*#__PURE__*/React.createElement(ButtonGroup, {
        data: _this.parseButtonData()
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderNotificationContent", function () {
      var _this$props8 = _this.props,
          showNotificationIcon = _this$props8.showNotificationIcon,
          hideCloseButton = _this$props8.hideCloseButton,
          showCloseIcon = _this$props8.showCloseIcon,
          layout = _this$props8.layout,
          title = _this$props8.title,
          subtitle = _this$props8.subtitle,
          viewport = _this$props8.viewport;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ContentWrapper, {
        showNotificationIcon: showNotificationIcon,
        hideCloseButton: hideCloseButton || showCloseIcon,
        layout: layout,
        viewport: viewport,
        contentTitle: title,
        subtitle: subtitle
      }, _this.renderText(), showNotificationIcon && _this.renderButtons()));
    });

    _defineProperty(_assertThisInitialized(_this), "renderAlertWithoutTransition", function () {
      var _this$props9 = _this.props,
          alertType = _this$props9.alertType,
          type = _this$props9.type,
          className = _this$props9.className,
          disableAnimation = _this$props9.disableAnimation,
          bodyConfig = _this$props9.bodyConfig,
          colorConfig = _this$props9.colorConfig,
          viewport = _this$props9.viewport,
          hasViewport = _this$props9.hasViewport,
          minHeight = _this$props9.minHeight,
          inlineTreatment = _this$props9.inlineTreatment,
          fullBleed = _this$props9.fullBleed,
          layout = _this$props9.layout,
          analyticsTrack = _this$props9['data-analyticstrack'],
          track = _this$props9['data-track'],
          clickStream = _this$props9['data-clickstream'];
      var visible = _this.state.visible;
      return /*#__PURE__*/React.createElement(AlertWrapper, {
        minHeight: minHeight,
        hasViewport: hasViewport,
        viewport: hasViewport ? viewport : null,
        bodyConfig: bodyConfig,
        alertType: alertType,
        type: type,
        tabIndex: -1,
        style: {
          opacity: visible ? 1 : 0,
          height: visible ? 'auto' : 0,
          display: visible ? 'flex' : 'none'
        },
        className: className,
        "data-testid": "alert",
        disableAnimation: disableAnimation,
        colorConfig: colorConfig,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-clickstream": clickStream,
        inlineTreatment: inlineTreatment,
        fullBleed: fullBleed
      }, _this.renderNotificationContent());
    });

    _defineProperty(_assertThisInitialized(_this), "renderAlertWithTransition", function () {
      var _this$props10 = _this.props,
          alertType = _this$props10.alertType,
          type = _this$props10.type,
          children = _this$props10.children,
          className = _this$props10.className,
          colorConfig = _this$props10.colorConfig,
          bodyConfig = _this$props10.bodyConfig,
          viewport = _this$props10.viewport,
          minHeight = _this$props10.minHeight,
          animateIn = _this$props10.animateIn,
          animateOut = _this$props10.animateOut,
          hasViewport = _this$props10.hasViewport,
          animationProperties = _this$props10.animationProperties,
          inlineTreatment = _this$props10.inlineTreatment,
          fullBleed = _this$props10.fullBleed,
          layout = _this$props10.layout,
          analyticsTrack = _this$props10['data-analyticstrack'],
          track = _this$props10['data-track'],
          clickStream = _this$props10['data-clickstream'];
      var _this$state = _this.state,
          visible = _this$state.visible,
          unmounted = _this$state.unmounted,
          containerHeight = _this$state.containerHeight;
      return visible && /*#__PURE__*/React.createElement(AlertWrapper, {
        animateIn: animateIn,
        animateOut: animateOut,
        animationProperties: animationProperties,
        containerHeight: containerHeight,
        minHeight: minHeight,
        hasViewport: hasViewport,
        viewport: hasViewport ? viewport : null,
        bodyConfig: bodyConfig,
        alertType: alertType,
        type: type,
        "data-testid": "alert",
        unmounted: unmounted,
        colorConfig: colorConfig,
        tabIndex: -1,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-clickstream": clickStream,
        inlineTreatment: inlineTreatment,
        fullBleed: fullBleed
      }, _this.renderNotificationContent());
    });

    _this.state = {
      visible: true,
      unmounted: false,
      containerHeight: 0,
      role: 'alert'
    }; // custom id's in order to use aria-* properties

    _this.titleID = "title_".concat(cuid());
    _this.subtitleID = "subtitle_".concat(cuid());
    _this.typeID = "type_".concat(cuid());
    _this.childrenId = "children_".concat(cuid());
    return _this;
  } // role text for iOS devices


  _createClass(Notification, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props11 = this.props,
          disableAnimation = _this$props11.disableAnimation,
          fullBleed = _this$props11.fullBleed,
          focusState = _this$props11.focusState,
          maxWidth = _this$props11.maxWidth,
          id = _this$props11.id,
          type = _this$props11.type,
          className = _this$props11.className;
      return /*#__PURE__*/React.createElement(StyledDiv, {
        id: id,
        className: className,
        focusState: focusState,
        maxWidth: maxWidth,
        fullBleed: fullBleed,
        containerHeight: this.state.containerHeight,
        tabIndex: -1,
        innerRef: function innerRef(input) {
          _this2.wrapper = input;
        }
      }, disableAnimation ? this.renderAlertWithoutTransition() : this.renderAlertWithTransition());
    }
  }]);

  return Notification;
}(Component);

Notification.propTypes = propTypes;
Notification.defaultProps = defaultProps;
export default withVDSManager(Notification);